// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaArrowLeft } from 'react-icons/fa';

const PageHeader = ({ showBackButton = false, backTo = "/" }) => {
  return (
    <nav className="bg-white shadow-sm py-4 sticky top-0 z-50">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2">
          <div className="p-1.5 bg-rose-500/10 border border-rose-500/20 rounded-lg shadow-sm">
            <FaHeart className="text-rose-600 text-xl" />
          </div>
          <span className="text-2xl font-bold tracking-wide">
            <span className="text-gray-900">Kalyana </span>
            <span className="text-rose-600">Matrimony</span>
          </span>
        </Link>

        {showBackButton && (
          <Link to={backTo} className="flex items-center text-gray-600 hover:text-rose-600 font-medium">
            <FaArrowLeft className="mr-2" /> Back to Home
          </Link>
        )}
      </div>
    </nav>
  );
};

export default PageHeader;